import React from 'react';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
import { ROUTE_PATH } from '../../../routes/route-paths';

export interface ThankYouStepProps {
  className?: string;
  onClose?: () => void;
}

// Checkmark icon component
const CheckmarkIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="32" cy="32" r="32" fill="#E8FFF0" />
    <circle cx="32" cy="32" r="24" fill="#AFFF54" />
    <path d="M26 32L30 36L38 28" stroke="#101828" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const ThankYouStep: React.FC<ThankYouStepProps> = ({ className, onClose }) => (
  <div className={twMerge('flex flex-col items-center gap-6 py-8', className)}>
    <CheckmarkIcon />

    <div className="flex flex-col items-center gap-2 text-center">
      <h2 className="text-label-gray font-['Albert_Sans'] text-2xl font-bold leading-8">Thank you!</h2>
      <p className="text-body-gray font-['Albert_Sans'] text-base font-normal leading-6">
        Your feedback has been submitted successfully.
      </p>
    </div>

    <Link
      to={ROUTE_PATH.HOME}
      replace
      className={twMerge(
        "bg-accent hover:bg-accent-hover flex h-12 items-center justify-center rounded-full px-8 font-['Albert_Sans'] text-base font-medium text-white transition-colors",
        onClose && 'md:hidden',
      )}
    >
      Close
    </Link>

    <div className="mt-4 flex flex-col items-center gap-3">
      <Link
        to={ROUTE_PATH.SUPPORT}
        className="text-label-gray flex items-center gap-2 font-['Albert_Sans'] text-sm font-medium underline-offset-2 hover:underline"
      >
        Contact support
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6 12L10 8L6 4"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </Link>
      <Link
        to={ROUTE_PATH.SUPPORT}
        className="text-label-gray flex items-center gap-2 font-['Albert_Sans'] text-sm font-medium underline-offset-2 hover:underline"
      >
        Report call
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6 12L10 8L6 4"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </Link>
    </div>
  </div>
);
